import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import holidayCalendarStore from "@/store/holidayCalendarStore";
import {
  IHoliday,
  checkHoliday,
  returnHolidaysForDate,
} from "@/store/holidayCalendarStoreACTIONS";

// Typing a date fires a change per keystroke; wait for it to settle before asking.
export const HOLIDAY_CHECK_DEBOUNCE_MS = 400;

// LQC-2985 - the holidays a date falls on, among the given calendars. Never blocks the
// input: until an answer lands the date simply shows as not a holiday.
export function useHolidayCheck(date: string, calendarCodes: string[] = []): IHoliday[] {
  const { getAccessTokenSilently } = useAuth0();
  // Own debounce, not utilities' useDebounce: many tests mock @/lib/utilities.
  const [settledDate, setSettledDate] = useState("");
  const codesKey = calendarCodes.join(",");

  useEffect(() => {
    if (!codesKey || !date) return;
    const timer = setTimeout(() => setSettledDate(date), HOLIDAY_CHECK_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [date, codesKey]);

  useEffect(() => {
    if (!codesKey || !settledDate) return;
    codesKey
      .split(",")
      .forEach((code) => checkHoliday(code, settledDate, getAccessTokenSilently));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settledDate, codesKey]);

  const holidayChecksByKey = holidayCalendarStore((state) => state.holidayChecksByKey);
  // Keyed by the live date, so a stale answer never highlights a newer date.
  return returnHolidaysForDate(holidayChecksByKey, date, calendarCodes);
}
